import { FormSelectYesNo } from '../../formelements'

export const AuthDretsImatge = ({ auth, handleChange, error, major18 }) => {

    return (<>
        <div className="row">
            <div className="col col-12 ">
                <h4>
                    Drets d'imatge
                </h4>

                    <FormSelectYesNo
                        id="authDretsImatge"
                        name="authDretsImatge"
                        col="col-1"
                        label="Trieu una opció:"
                        obligatori={true}
                        value={auth}
                        handleChange={(e) => handleChange(e.target.value)}
                        error={error}
                        />

                    <p>
                    <label htmlFor="authDretsImatge">
                        AUTORITZO
                        {!major18 ? (<> que la imatge i/o veu de l'alumne/a matriculat/ada </>) : (<> que la meva imatge i/o veu </>)}
                        pugui aparèixer en fotografies i vídeos corresponents a
                        les activitats lectives, complementàries, extraescolars i de promoció i difusó organitzades per l'institut i publicades a pàgines WEB,
                        xarxes socials, filmacions no comercials o revistes i publicacions d'àmbit educatiu.
                    </label>
                    <span id="auhtDretsImatge_ERROR" className="a-Form-error">{error}</span>
                </p>
            </div>
        </div>

        <br />
    </>)

}